import Auth from './src/main'
import { addComponent } from '~/utils/helper'

export default addComponent(Auth)


// WEBPACK FOOTER //
// ./public/auth/index.js